// angular
import {Injectable} from '@angular/core';
// rxjs
import {BehaviorSubject, Observable} from 'rxjs';
// models
import {Membership, OrderStatus, StatusesFromServer, SubscriptionOrderStatus} from '../models/order.model';
import {Customer} from '../models/customer.model';
// services
import {PaymentService} from '../services/payment.service';
import {RouteService} from '../services/route.service';
import {OrderApiService} from '../services/order.api.service';

@Injectable()
export class OrderStore {
  private _pendingOrdersStatus$ = new BehaviorSubject<OrderStatus[]>([]);
  private _pastOrdersStatus$ = new BehaviorSubject<OrderStatus[]>([]);
  private _archiveOrdersStatus$ = new BehaviorSubject<OrderStatus[]>([]);
  private _subscriptionsOrderHistory$ = new BehaviorSubject<OrderStatus[]>([]);
  private _subscriptionsUpcomingOrders$ = new BehaviorSubject<OrderStatus[]>([]);
  private _subscriptionsActive$ = new BehaviorSubject<SubscriptionOrderStatus[]>([]);
  private _isLoadingStatuses$ = new BehaviorSubject<boolean>(false);
  private _isLoadingStatusesUpdate$ = new BehaviorSubject<boolean>(false);
  private _memberships$ = new BehaviorSubject<Membership[]>([]);

  get pendingOrdersStatus$(): Observable<OrderStatus[]> {
    return this._pendingOrdersStatus$.asObservable();
  }

  get pastOrdersStatus$(): Observable<OrderStatus[]> {
    return this._pastOrdersStatus$.asObservable();
  }

  get subscriptionsOrderHistory$(): Observable<OrderStatus[]> {
    return this._subscriptionsOrderHistory$.asObservable();
  }

  get subscriptionsUpcomingOrders$(): Observable<OrderStatus[]> {
    return this._subscriptionsUpcomingOrders$.asObservable();
  }

  get subscriptionsActive$(): Observable<SubscriptionOrderStatus[]> {
    return this._subscriptionsActive$.asObservable();
  }

  get isLoadingStatuses$(): Observable<boolean> {
    return this._isLoadingStatuses$.asObservable();
  }

  get isLoadingStatusesUpdate$(): Observable<boolean> {
    return this._isLoadingStatusesUpdate$.asObservable();
  }

  get memberships$(): Observable<Membership[]> {
    return this._memberships$.asObservable();
  }

  constructor(
    private orderApiService: OrderApiService
  ) {
  }

  public bootstrapAllPendingOrderStatus(locationId: string, isOnlyPending: boolean, isGroup?: boolean): void {
    this._isLoadingStatuses$.next(true);
    this.orderApiService.getAllOrdersList(locationId, isOnlyPending, isGroup)
      .subscribe(allPendingOrdersStatus => {
        this._pendingOrdersStatus$.next(allPendingOrdersStatus);
        this._isLoadingStatuses$.next(false);
      });
  }

  public updateOrderStatus(status: string, locationId: string, orderId: string): void {
    this._isLoadingStatusesUpdate$.next(true);
      this.orderApiService.updateOrderStatus(status, locationId, orderId)
        .subscribe((squareOrder) => {
          const idForUpdatedOrder: string = squareOrder['id'];
          const updatedStatus: string = squareOrder['fulfillments'][0]['state'];

          this.updateOrdersArray(idForUpdatedOrder, updatedStatus);
          this._isLoadingStatusesUpdate$.next(false);
        });
  }

  public archiveOrder(status: string, orderId: string) {
    const lastStatusFormServer = StatusesFromServer[3];

    if (status === lastStatusFormServer) {
      const archiveOrders: OrderStatus[] = this.removeOrderFromArray(orderId);
      this._archiveOrdersStatus$.next(archiveOrders);
    } else {
      console.error(`Incorrect status to archive: ${status}`);
    }
  }

  public getMemberships(customerId: string, locationId?: string, merchantId?: string) {
    this.orderApiService.getCustomerMemberships(customerId, locationId, merchantId)
      .subscribe((memberships) => {
        this._memberships$.next(memberships)
      })
  }

  public cancelMembership(membershipId: string) {
    this.orderApiService.cancelMembership(membershipId)
  }

  private updateOrdersArray(idForUpdatedOrder: string, updatedStatus: string) {
    const updatedOrders = this._pendingOrdersStatus$
      .getValue()
      .map(order => {
        if (idForUpdatedOrder === order.orderId) {
          order.status = updatedStatus;
        }
        return order;
      });
    this._pendingOrdersStatus$.next(updatedOrders);
  }

  private removeOrderFromArray(orderId: string): OrderStatus[] {
    const newOrdersArray = this._pendingOrdersStatus$.getValue()
      .filter(order => order.orderId !== orderId);

    this._pendingOrdersStatus$.next(newOrdersArray);
    return newOrdersArray;
  }

}
